import { render, staticRenderFns } from "./AddSystem.vue?vue&type=template&id=470abed0&scoped=true&"
import script from "./AddSystem.vue?vue&type=script&lang=js&"
export * from "./AddSystem.vue?vue&type=script&lang=js&"
import style0 from "./AddSystem.vue?vue&type=style&index=0&id=470abed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470abed0",
  null
  
)

export default component.exports